import { IsNotEmpty } from "class-validator";


export class CustomerWorkoutCreateFormData {
    @IsNotEmpty()
    name: string;

    // @IsNotEmpty()
    // sets: WorkoutSetCreatUpdate[];
    
}
